export default __webpack_public_path__ + "ca9fc23cd13f667a94d1e2c63b8e9762.svg";